import * as types from "../action/ActionType";
import type { AppAction } from "../action/ActionType";

export type InvoiceFormDataState = Record<string, unknown>;

export default function Invoiceformdata(
  state: InvoiceFormDataState = {},
  action: AppAction
): InvoiceFormDataState {
  switch (action.type) {
    case types.UPDATE_FORMDATA:
      return action.payload;
    default:
      return state;
  }
}
